import { connect } from 'react-redux'
import atomicMassForm from '../ui/forms/atomicMassForm'
import { setAtomicMassValues } from '../../store/actions/atomicMassActions'

const mapStateToProps = state => ({
    atomicMassValues: state.formulas.atomicMass
})

const mapDispatchToProps = dispatch => {
    return {
        formToState: (val) => {
            dispatch(
                setAtomicMassValues(val)
            )
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(atomicMassForm)